/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Scroll_Speed_LabelInputs */



/**
* | output |
* | --- |
* | "Scroll speed" |
*
* @param {Audio_Recorder_Scroll_Speed_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_scroll_speed_label = /** @type {((inputs?: Audio_Recorder_Scroll_Speed_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Scroll_Speed_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vitesse de défilement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scrollgeschwindigkeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("velocità di scorrimento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("скорость прокрутки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de desplazamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("滚动速度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スクロール速度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रॉल गति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Velocidade de rolagem")
	return /** @type {LocalizedString} */ ("Scroll speed")
});